import { Routes } from '@angular/router';
import { SignInPage } from './pages/sign-in-page/sign-in-page';
import { ResetPasswordPage } from './pages/reset-password-page/reset-password-page';
import { StylesPage } from './pages/styles-page/styles-page';
import { DocumentationPage } from './pages/documentation-page/documentation-page';

export const routes: Routes = [
    { path: '', redirectTo: 'sign-in', pathMatch: 'full' },
    { path: 'sign-in', component: SignInPage },
    { path: 'reset-password', component: ResetPasswordPage },
    { path: 'styles', component: StylesPage },
    { path: 'documentation', component: DocumentationPage }
];
